module.exports = __webpack_public_path__ + "static/desktop-dashboard-32bc3f320d83f96547610f6ac67aa752.jpg";